// CancelarSuscripcionPage.js — /cancelar-suscripcion?t=<token> (fase 8).
// Página pública del enlace que llega en el recordatorio de vencimiento: muestra
// el plan y la fecha y permite cancelar la renovación diciendo el motivo, sin
// iniciar sesión. Con el enlace vencido explica cómo hacerlo desde el perfil.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import { useProject } from '../contexts/ProjectContext';
import FormCancelar, { fechaLarga } from '../components/suscripcion/FormCancelar';

const Fondo = styled.div`
  min-height: 100vh; display: grid; place-items: center; padding: 7rem 1.25rem 3rem; box-sizing: border-box; background: #f1f5f9;
  font-family: 'Inter', system-ui, sans-serif;
`;
const Caja = styled.div`
  width: min(620px, 100%); padding: clamp(1.4rem, 4vw, 2.2rem); border-radius: 20px; background: #fff; box-shadow: 0 20px 60px -30px rgba(15,23,42,.35);
  h1 { margin: 0 0 .4rem; font-size: 1.6rem; color: #0f172a; }
  > p { margin: 0 0 1.4rem; color: #475569; line-height: 1.55; }
  .dato { display: inline-flex; gap: .4rem; flex-wrap: wrap; margin-bottom: 1.4rem; padding: .45rem .9rem; border-radius: 999px; background: #f1f5f9; font-size: .9rem; color: #334155; }
  .ok { display: grid; place-items: center; width: 64px; height: 64px; margin-bottom: 1rem; border-radius: 50%; background: #dcfce7; color: #16a34a; }
  .ok svg { width: 30px; height: 30px; }
  a.btn { display: inline-flex; align-items: center; height: 46px; padding: 0 1.3rem; border-radius: 10px; font-weight: 700; text-decoration: none; color: #fff; }
`;

const CancelarSuscripcionPage = () => {
  const [q] = useSearchParams();
  const token = q.get('t') || '';
  const { proyecto } = useProject();
  const acento = proyecto?.color_primario || '#0f355b';
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState('');
  const [listo, setListo] = useState(null);

  useEffect(() => {
    if (!token) { setError('Falta el enlace de cancelación. Entra a tu cuenta y cancela desde «Mi suscripción».'); return; }
    axios.get(`${API_BASE_URL}/suscripcion-cancelar.php`, { params: { t: token } })
      .then(r => setDatos(r.data)).catch(e => setError(e.response?.data?.error || 'No pudimos abrir el enlace.'));
  }, [token]);

  return (
    <Fondo>
      <Caja>
        {error ? (
          <>
            <h1>No pudimos abrir este enlace</h1>
            <p>{error}</p>
            <Link className="btn" to="/perfil?pestana=suscripcion" style={{ background: acento }}>Ir a mi suscripción</Link>
          </>
        ) : !datos ? <p>Cargando…</p> : listo || datos.cancelada ? (
          <>
            <div className="ok" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg></div>
            <h1>Renovación cancelada</h1>
            <p>No se te volverá a cobrar. Sigues teniendo acceso hasta el <b>{fechaLarga(datos.vence_en)}</b>. Si cambias de opinión, puedes renovar cuando quieras.</p>
            <Link className="btn" to="/" style={{ background: acento }}>Ir a mis cursos</Link>
          </>
        ) : (
          <>
            <h1>{datos.nombre ? `${datos.nombre}, ¿quieres cancelar?` : '¿Quieres cancelar tu suscripción?'}</h1>
            <p>Lamentamos verte ir. Cuéntanos el motivo: nos ayuda a mejorar.</p>
            <div className="dato">
              {datos.plan && <span>Plan <b>{datos.plan}</b></span>}
              {datos.vence_en && <span>· acceso hasta el <b>{fechaLarga(datos.vence_en)}</b></span>}
              {datos.proyecto && <span>· {datos.proyecto}</span>}
            </div>
            <FormCancelar token={token} venceEn={datos.vence_en} categorias={datos.categorias} acento={acento} onListo={() => setListo(true)} />
          </>
        )}
      </Caja>
    </Fondo>
  );
};

export default CancelarSuscripcionPage;
